<template>
  <b-modal @shown='shown' id='modal-center' centered
    ref='modal'
    title='' size='spot modal-large' :hide-footer='true'>
    <p class="my-3">
      <b>GPS:</b> {{ coordsString }}
      <button
        class='btn btn-link btn-sm'
        style='border: none;'
        @click='copyCords'>
        (copy)
      </button>
    </p>
    <input type='text' ref='copyInput' style='opacity: 0; position: absolute;' v-model='coordsString'>
    <b-row>
      <b-col lg='5'>
        <div class='show-place-list scroll ver'>
          <spot-info
            v-for='place in modalPlaces'
            :key='`place_${place.placeId}_${place.order}`'
            :place='place'
            ref='spotInfo' />
        </div>
      </b-col>
      <b-col lg='7'>
        <div id='modal-map' ref='modalMap' />
        <div
          style='position: absolute; top: 45%; left: 0; right: 0;'
          v-show='!modalMarkers.length'>
          <div class='bold border border-secondary m-auto px-5 py-3'
            style='background-color: white; width: max-content;'>
            Service Area Business results only
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import toastr from 'toastr'
import Vue from 'vue'
import { BModal } from 'bootstrap-vue'
import { mapState } from 'vuex'
import {
  DEFAULT_CENTER, DEFAULT_ZOOM, renderMarker
} from '../../../common/map_helpers'
import spotInfo from './spot_info'

Vue.component('BModal', BModal)

export default {
  components: { spotInfo },
  data() {
    return {
      modalPlaces: [],
      modalMarkers: [],
      coordsString: null
    }
  },
  computed: mapState(['geogridSet']),
  watch: {
    geogridSet() {
      this.$refs.modal.show()
    }
  },
  methods: {
    copyCords() {
      this.$refs.copyInput.select()
      document.execCommand('copy')
    },
    shown() {
      // Problem is that after update bootstrap-vue, when modal is hidden
      // there is no elements of modal in DOM, so we can't mount map inside of
      // it, until modal appears.
      this.$modalMap = new google.maps.Map(this.$refs.modalMap, {
        center: DEFAULT_CENTER,
        zoom: DEFAULT_ZOOM,
        scaleControl: true
      })
      this.$nextTick(() => {
        this.createBounds(this.geogridSet)
      })
    },
    createBounds(el) {
      this.coordsString = `latitude:  ${el.latitude} longitude: ${el.longitude}`
      this.modalMarkers.forEach((m) => {
        google.maps.event.clearListeners(m, 'click')
        m.setMap(null)
      })
      this.modalMarkers = []

      this.modalPlaces = el.placesSpots
        .sort((a, b) => (a.order > b.order ? 1 : -1))
        .map((b) => ({ ...b, selected: false }))

      if (this.modalPlaces.length) {
        const modalBounds = new google.maps.LatLngBounds()

        // If place does not contain address it also usually has odd coordinates, as result
        // we sometimes draw points in the middle of ocean. Lets skip those places on map.
        this.modalPlaces
          .filter((p) => p.address != null && p.lat != null && p.lon != null)
          .forEach((p) => {
            const zindex = p.order
            const modalMarker = renderMarker(
              parseFloat(p.lat, 10),
              parseFloat(p.lon, 10),
              this.$modalMap,
              zindex,
              p.order
            )

            const modalLoc = new google.maps.LatLng(modalMarker.position.lat(), modalMarker.position.lng())
            modalBounds.extend(modalLoc)

            modalMarker.addListener('click', () => {
              const selected = this.modalPlaces.find((v) => v.selected)
              if (selected) selected.selected = false
              p.selected = true // eslint-disable-line no-param-reassign
            })

            this.modalMarkers.push(modalMarker)
          })
        if (this.modalMarkers.length) this.$modalMap.fitBounds(modalBounds)
        else this.$modalMap.setCenter(new google.maps.LatLng(el.latitude, el.longitude))
      } else {
        toastr.info('Sorry! no places for this spot.')
      }
    }
  }
}
</script>

<style scoped>
  .show-place-list {
    max-height: 66.5vh;
    overflow-y: auto;
    overflow-x: hidden;
  }
  #modal-map {
    height: 66.5vh;
    border: solid 2px #dfdfdf;
  }
</style>
